import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule,routingcomponents} from './app-routing.module';
import {AppComponent } from './app.component';
import {NavbarComponent } from './navbar/navbar.component';
import {SidebarComponent } from './sidebar/sidebar.component';
// import {DataTablesModule } from 'angular-datatables';
import {HttpClientModule,HTTP_INTERCEPTORS} from "@angular/common/http";
import {FormsModule} from "@angular/forms";
import {ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TokenInterceptorService } from './token-interceptor.service';
import { DashboardGraphComponent } from './dashboard-graph/dashboard-graph.component';
import { NgxDateRangeModule } from 'ngx-daterange';
import { AuthGuard } from './auth.guard';
import { ProductGuard } from './product.guard';
// import { GoogleChartsModule } from 'angular-google-charts';
import { DatePipe } from '@angular/common';
import { ResolverService } from '../app/resolver.service'; 
import { HashLocationStrategy, LocationStrategy } from'@angular/common';

// third-party js lib
//import { babel } from '../../node_modules/babel-loader';

@NgModule({
  declarations: [
    AppComponent,
    routingcomponents,
    NavbarComponent,
    SidebarComponent,
    DashboardGraphComponent
    
    ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    // DataTablesModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgxDateRangeModule,
    // GoogleChartsModule
  ],
  providers: [DatePipe,AuthGuard,ResolverService,ProductGuard,{
    provide:HTTP_INTERCEPTORS,
    useClass:TokenInterceptorService,
    multi:true
  },{
    provide:LocationStrategy,
    useClass :HashLocationStrategy
  }],
  bootstrap: [AppComponent]

})
  //loaders : [babel]
export class AppModule { }
